<match-display-wrapper
    class="http-status-match-readonly"
    matchLabel="{{ globalL10nKeys.httpStatusMatchLabel | vtranslate }}"
    matchCriteria="{{ matchCriteria }}"
>
    <ng-container *ngIf="statusCodesAndRanges?.length">
        <div *ngFor="let rangeOrCode of statusCodesAndRanges; trackBy: trackByIndex">
            {{ rangeOrCode }}
        </div>
    </ng-container>
</match-display-wrapper>
